/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import Label from 'DesignSystem/Label/index'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import XIcon from 'DesignSystem/Svgs/XIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Comparison/Content/Content/Actions/Choose/ImageSelect/Content/CloseAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 marginLeft={4}
 paddingTop={4}
 paddingBottom={4}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
>
{childProps => (
<div
  data-testid="CloseAction.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<XIcon
  viewPath={`${viewPath}/XIcon`}
/>
<Label
  viewPath={`${viewPath}/Label`}
 marginTop={4}
 text="ESC"
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 onPress={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
/>
</div>
)}
</ButtonIcon>
{children}
</React.Fragment>)
}